import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Table
} from "react-bootstrap-v5";
import { MdEdit, MdVisibility } from "react-icons/md";

import * as JobOptions from "../../../Function/defaultJobOptions";
import PickUpServices from "../../../Services/PickUpService";
// import { useLocation } from 'react-router-dom'
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import CheckAccess from "../../../Function/CheckAccess";
import { reportService } from "../../../Services/reportService";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

let currentPage1 = 1;
class PickUpList extends Component {
  state = {
    pickUpList: [],
    itemData: {},
    startDate: "",
    endDate: "",
    user_type: localStorage.getItem("user_type"),
    loader: true,
    pagination: { page: 1, limit: 10, totalRecord: 0 },
    currentPage: currentPage1,
    searchText: "",
    dropdownText: "",
  };

  componentDidMount() {
    this.fetchPickUpList();
  }

  fetchPickUpList = () => {
    const { pagination, currentPage, searchText, dropdownText, startDate, endDate } = this.state;
    let param = {
      limit: pagination.limit,
      page: currentPage,
      search: searchText,
      status: dropdownText,
      startDate: startDate,
      endDate: endDate,
    };
    PickUpServices.getPickUpList(param).then((result) => {
      if (result.status === true) {
        this.setState({
          pickUpList: result.data,
          pagination: {
            ...pagination,
            totalRecord: result.pagination.totalRecord,
          },
          loader: false,
        });
      } else {
        this.setState({ loader: false });
      }
    });
  };

  handleSearch = (event) => {
    this.setState({ searchText: event.target.value, currentPage: 1 }, () => {
      this.fetchPickUpList();
    });
  };

  handleChangeValue = (event) => {
    this.setState({ dropdownText: event.target.value, currentPage: 1 }, () => {
      this.fetchPickUpList();
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    let setdate = name === "start_date" ? "startDate" : "endDate";
    this.setState(
      { [setdate]: new Date(value).getTime(), currentPage: 1 },
      () => {
        if (this.state.startDate && this.state.endDate) {
          this.fetchPickUpList();
        }
      }
    );
  };

  onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    this.setState({ loader: true, currentPage: e.selected + 1 }, () => {
      this.fetchPickUpList();
    });
  };

  exportToExcel = () => {
    const { pagination, currentPage, searchText, dropdownText, startDate, endDate } = this.state;
    let params = {
      limit: pagination.limit,
      page: currentPage,
      search: searchText,
      status: dropdownText,
      startDate: startDate,
      endDate: endDate,
    };
    PickUpServices.getPickUpListExport(params).then(result => {
      if (result.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
      } else {
        toast.error("Something went wrong")
      }
    })
  }

  render() {
    const { pickUpList, user_type, loader, pagination, currentPage } =
      this.state;
    const { location } = this.props;

    // if (pickUpList.length == 0) return false;

    return (
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <div className="d-flex justify-content-between mb-3">
                <Col md={3} className="mb-3 pe-3">
                  <Form.Label>Filter</Form.Label>
                  <input
                    type="text"
                    className={"form-control"}
                    placeholder="Search..."
                    onKeyUp={(e) => this.handleSearch(e)}
                  />
                </Col>
                <Col md={3} className="mb-3 pe-3">
                  <Form.Label>Pick up status</Form.Label>
                  <Form.Select
                    name="pickup_status"
                    onChange={(e) => this.handleChangeValue(e, "")}
                  >
                    <option value="">Select Status</option>
                    {/* value={JobOptions.statusOption().filter(obj => obj.value === itemData.pickup_status)} */}

                    {JobOptions.statusOption().length &&
                      JobOptions.statusOption().map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                  </Form.Select>
                </Col>
                <Col md={2} className="pe-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="start_date"
                    onChange={(e) => this.handleDateChange(e)}
                  />
                </Col>
                <Col md={22} className='pe-3'>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="end_date"
                    onChange={(e) => this.handleDateChange(e)}
                  />
                </Col>
                <Col md={2} className="pt-4">
                  <Button className="me-2 w-100 py-1" variant="success"
                    onClick={() => this.exportToExcel()}
                  > Excel </Button>
                </Col>

                {/* <button
									className="btn btn-primary w-sm waves-effect waves-light"
									onClick={() => this.props.history.push("/add-pick-up")}
								>
									Add Pickup
								</button> */}
              </div>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>S no.</th>
                    <th>Job No.</th>
                    <th> Customer Name</th>
                    <th>Pick Up Location</th>
                    <th>PickUp Contact No</th>
                    <th>Pickup Assign</th>
                    <th>Pick Up Date</th>
                    <th>Status</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {pickUpList.length == 0 && (
                    <tr>
                      <td colSpan="9" align="center">
                        No Data
                      </td>
                    </tr>
                  )}
                  {pickUpList.length > 0 &&
                    pickUpList.map((item, index) => {
                      return (
                        <tr>
                          {/* <td scope="row">{index + 1}</td> */}
                          <td className="text-body fw-bold">
                            {(currentPage - 1) * pagination.limit + (index + 1)}
                          </td>
                          <td>{item?.job_token}</td>
                          <td>{item?.job_details?.customer_details?.name}</td>
                          <td>{item?.pickup_address}</td>
                          <td>{item?.phone_number}</td>
                          <td>{item?.pickup_type}</td>
                          <td>{item?.pickup_date}</td>
                          <td>{item?.pickup_status}</td>
                          <td>
                            {CheckAccess(44, "edit") && (
                              <MdEdit
                                className="pointer"
                                color="#0323fe"
                                size="25px"
                                onClick={() => {
                                  this.props.history.push(
                                    "/edit-pick-up?id=" + item._id
                                  )
                                }
                                }
                              />
                            )}
                            {/* <MdDeleteForever
													className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
													className="pointer"
													color="red"
													size="25px"
												/> */}
                            <MdVisibility
                              onClick={() => {
                                  this.props.history.push(
                                    "/view-pick-up?id=" + item._id
                                  )
                                }
                                }
                              className="pointer"
                              color="#0323fe"
                              size="25px"
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              {pickUpList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="prev"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="next"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={this.onPageChangeEvent}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
              <Loader isShow={loader} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { PickUpList };

